import api from '@/utils/axios'

export default {
  // 获取 mqtt token
  getApplyToken() {
    return api.get('/api/yiyuan/platform/mqtt/getApplyToken', null, {
      mock: false,
      showError: false,
      // isSdApi: true
    })
  },
  // 密码登录
  postPasswordLogin(body) {
    return api.post('/api/yiyuan/platform/user/login/passwordLogin', body)
  },
  // 验证码登录
  postVerifyCodeLogin(body) {
    return api.post('/api/yiyuan/platform/user/login/mobileVerifyCodeLogin', body)
  },
  // 验证码登录-获取验证码
  sendVerifyCodeFromLogin(body) {
    return api.post('/api/yiyuan/platform/user/login/sendPhoneVerifyCode', body)
  },
  // 用户注册
  postUserRegister(body) {
    return api.post('/api/yiyuan/platform/user/register/registerUser', body)
  },
  // 注册-获取验证码
  sendVerifyCodeFormRegister(body) {
    return api.post('/api/yiyuan/platform/user/register/sendPhoneVerifyCode', body)
  },
  // 重置密码
  postResetPassword(body) {
    return api.post('/api/yiyuan/platform/user/login/resetPassword', body)
  },
  // 重置密码-获取验证码
  sendVerifyCodeFormReset(body) {
    return api.post('/api/yiyuan/platform/user/login/resetPassword/sendPhoneVerifyCode', body)
  },
  // 文件上传-获取policy授权信息
  getUploadPolicy(body) {
    return api.get('/api/yiyuan/platform/getOssPolicy', body, {
      mock: false,
    })
  },
  // 查询推广素材
  queryProductMaterial(body) {
    return api.post('/api/yiyuan/platform/corp/queryCreatives', body, { mock: false })
  },
  //查询合伙人入驻信息
  getPartnerJoinInfo(body) {
    return api.post('/api/yiyuan/platform/corp/queryInfo', body)
  },
  //身份证正面ocr
  postIdCardFrontOcr(body) {
    return api.get('/api/yiyuan/platform/ocr/ocrIdentityCardFront', body)
  },
  //身份证反面ocr
  postIdCardBackOcr(body) {
    return api.get('/api/yiyuan/platform/ocr/ocrIdentityCardBack', body)
  },
  //营业执照ocr
  postBusinessLicenseOcr(body) {
    return api.get('/api/yiyuan/platform/ocr/ocrBusinessLicense', body)
  },
  //合伙人入驻
  postPartnerJoin(body) {
    return api.post('/api/yiyuan/platform/corp/onboardSubmit', body)
  },
  //获取合伙人入驻付款信息
  getPartnerJoinPaymentInfo(body) {
    return api.get('/api/yiyuan/platform/corp/queryTransferAccount', body)
  },
  //提交付款截图
  submitPaymentProof(body) {
    return api.post('/api/yiyuan/platform/corp/uploadPaymentProof', body)
  },
  // 合同签署
  postSignAgreement(body) {
    return api.post('/api/yiyuan/platform/protocol/sign', body)
  },
  // 查询合伙人入驻状态
  getPartnerJoinStatus(body) {
    return api.post('/api/yiyuan/platform/corp/queryCorpStatus', body, {
      isCancelRequest: false,
    })
  },

  //查询签署协议地址url
  getSignAgreementUrl(body) {
    return api.post('/api/yiyuan/platform/protocol/signUrl', body)
  },

  //客户取消流程
  postCancelJoinProcess(body) {
    return api.post('/api/yiyuan/platform/corp/cancel', body)
  },
  //风控、三要素验证
  postRiskVerification(body) {
    return api.post('/api/yiyuan/platform/corp/riskCheck', body)
  },
  postCustomerClue(body) {
    return api.post('/api/yiyuan/platform/customerClue', body)
  }
}
